import FormattedMessage from 'I18n/components/FormattedMessage';
import UIList from 'UIComponents/list/UIList';
import UIButton from 'UIComponents/button/UIButton';
import ModalWrapper from '../ModalWrapper';
import { track } from '../../../tracking/track';
import { events } from '../../../tracking/events';
import { useScopes } from 'growth-payments-core/auth/scopes';
import { INVOICES_WRITE } from '../../../constants/scopes';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import GoToProcessorPickerButtonWrapper from '../../GoToProcessorPickerButtonWrapper';
import { getCreateInvoicesURL } from 'growth-payments-core/urls/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const CollectPaymentsWithInvoicesModal = ({
  onClose,
  page,
  location,
  ButtonPrimary = GoToProcessorPickerButtonWrapper
}) => {
  const scopes = useScopes();
  const hasInvoicesWrite = scopes.has(INVOICES_WRITE);
  const Body = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embedPoints.collectPaymentsWithInvoicesModal.p1"
      })
    }), /*#__PURE__*/_jsxs(UIList, {
      styled: true,
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "embedPoints.collectPaymentsWithInvoicesModal.bullet1"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embedPoints.collectPaymentsWithInvoicesModal.bullet2"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embedPoints.collectPaymentsWithInvoicesModal.bullet3"
      })]
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "embedPoints.collectPaymentsWithInvoicesModal.p2"
    })]
  });
  const Footer = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ButtonPrimary, {
      sourceApp: page,
      location: location,
      use: "primary"
    }), /*#__PURE__*/_jsx(UITooltip, {
      placement: "right",
      disabled: hasInvoicesWrite,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embedPoints.tooltips.missingPermissions"
      }),
      children: /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": "createInvoiceButton",
        disabled: !hasInvoicesWrite,
        use: "secondary",
        rel: "noopener" // override the rel attribute to remove the "noreferrer" tag, slack ref - https://hubspot.slack.com/archives/CEZNHE030/p1696003611704799
        ,
        external: true,
        href: getCreateInvoicesURL(),
        onClick: () => track(events.paymentsInterstitialModalInteraction, {
          action: 'click',
          screen: page,
          value: 'createInvoice'
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "embedPoints.ctas.createInvoice"
        })
      })
    })]
  });
  return /*#__PURE__*/_jsx(ModalWrapper, {
    onClose: onClose,
    modalName: "collectPaymentsWithInvoicesModal",
    Body: Body,
    Footer: Footer
  });
};
export default CollectPaymentsWithInvoicesModal;